<template>
  <div class="obras">
    <h2>
      Obras
      <img src="@/assets/icons/engineer.svg" alt="Ícone engenheiro" />
    </h2>

    <p>
      Equipe especializada em obras de shoppings, hospitais e prédios
      comerciais. Prestação de serviço para construtoras, onde nosso objetivo é
      fazer com que o cliente não possua condições de visualizar o perímetro da
      obra por estética ou por segurança.
    </p>

    <Carousel
      class="carousel"
      :class="{ fullscreen: isFullscreen }"
      v-slot="{ currentSlide }"
      htmlClass="slide-obras"
    >
      <!-- Botão aparece somente quando há slide ativo -->
      <img
        v-if="currentSlide"
        class="fullscreen-button"
        :src="isFullscreen 
          ? require('@/assets/icons/fullscreen-exit.svg')
          : require('@/assets/icons/fullscreen.svg')"
        :alt="isFullscreen ? 'Sair do fullscreen' : 'Entrar em fullscreen'"
        role="button"
        tabindex="0"
        @click.stop="toggleFullscreen"
        @keyup.enter="toggleFullscreen"
      />

      <Slide
        v-for="slide in totalSlides"
        :key="slide"
        htmlClass="slide-obras"
        @click="toggleFullscreen"
      >
        <div v-show="currentSlide === slide" class="slide-info">
          <img
            :src="images[slide - 1]"
            :alt="`Imagem obras ${slide}`"
          />
        </div>
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { ref } from "vue";
import Carousel from "@/components/Carousel/Carousel.vue";
import Slide from "@/components/Carousel/Slide.vue";

export default {
  name: "Obras",
  components: {
    Carousel,
    Slide,
  },
  setup() {
    const totalSlides = 34;
    const isFullscreen = ref(false);

    // Pré-carrega imagens uma única vez
    const images = Array.from({ length: totalSlides }, (_, i) => {
      const index = i + 1;
      try {
        return require(`@/img/obras/${index}.jpg`);
      } catch {
        return require(`@/img/obras/${index}.png`);
      }
    });

    const toggleFullscreen = () => {
      isFullscreen.value = !isFullscreen.value;
    };

    return {
      totalSlides,
      images,
      isFullscreen,
      toggleFullscreen,
    };
  },
};
</script>

<style lang="scss" scoped>
.obras {
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  p {
    max-width: 900px;
    line-height: 150%;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
  }
}

.carousel {
  margin-bottom: 2rem;
  position: relative;
  background: rgb(0, 0, 0);
  cursor: pointer;

  .fullscreen-button {
    position: absolute;
    height: 30px;
    z-index: 1;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
  }
}

.fullscreen {
  border-radius: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100vh;
  width: 100vw;
  max-width: 100%;

  .slide-info {
    height: 100vh;
  }
}

.slide-info {
  position: absolute;
  width: 100%;
  height: 600px; 

  img {
    border-radius: 0.75rem;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

@media (max-width: 900px) {
  .obras p {
    margin: 0 1rem 1.5rem;
  }

  .carousel {
    margin-bottom: 0;
  }

  .slide-info img {
    border-radius: 0;
  }
}
</style>